import React from "react";
import { useLocation } from 'react-router-dom';
import './message.css';

const Message = () => {
  const location = useLocation();
  const { text, type } = location.state || { text: '', type: 'error' };
  const isSuccess = type === 'success';

  return (
    <div className="sr-message">
      <div className="sr-message__top">
        <h1 className="sr-message__title">{isSuccess ? 'Success!' : 'Oops! Error...'}</h1>
      </div>
      <div className="sr-message__body">
        <p className="sr-message__text">{text}</p>
      </div>
    </div>
  );
}

export default Message;
